<template>
    <!-- Best Selling -->
    <section class="py-5">
        <div class="container">
            <div class="text-center mb-4">
                <h2 class="fw-bold font-serif mb-3">Best Selling This Week</h2>
                <div class="d-inline-flex gap-2">
                    <button class="btn btn-sm rounded-pill px-3" 
                        :class="activeTab === 'all' ? 'btn-brown' : 'btn-outline-brown border-0'"
                        @click="$emit('tab-change', 'all')">All Products</button>
                    <button class="btn btn-sm rounded-pill px-3"
                            :class="activeTab === 'new_arrivals' ? 'btn-brown' : 'btn-outline-brown border-0'"
                            @click="$emit('tab-change', 'new_arrivals')">New Arrivals</button>
                    <button class="btn btn-sm rounded-pill px-3"
                            :class="activeTab === 'best_sellers' ? 'btn-brown' : 'btn-outline-brown border-0'"
                            @click="$emit('tab-change', 'best_sellers')">Best Sellers</button>
                    <button class="btn btn-sm rounded-pill px-3"
                            :class="activeTab === 'top_rated' ? 'btn-brown' : 'btn-outline-brown border-0'"
                            @click="$emit('tab-change', 'top_rated')">Top Rated</button>
                </div>
            </div>

            <div v-if="renderCarousel" class="owl-carousel owl-theme product-carousel" id="productCarousel">
                <div class="item" v-for="product in products" :key="product.id">
                    <product-card :product="product" @add-to-cart="$emit('add-to-cart', product)"></product-card>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'owl.carousel/dist/assets/owl.carousel.css';
require('owl.carousel');

export default {
    name: "BestSellingSection",
    components: {
        ProductCard
    },
    props: {
        products: {
            type: Array,
            required: true
        },
        activeTab: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            renderCarousel: true
        }
    },
    watch: {
        products() {
            // Force re-render of the carousel element
            this.renderCarousel = false;
            
            this.$nextTick(() => {
                this.renderCarousel = true;
                this.$nextTick(() => {
                    this.initCarousel();
                });
            });
        }
    },
    mounted() {
        // Initialize if data is already present
        if(this.products.length > 0) {
            this.initCarousel();
        }
    },
    beforeDestroy() {
        // No manual destroy needed if we are destroying the DOM element, but good practice cleanup
        const carousel = $('#productCarousel');
        if (carousel.length && carousel.hasClass('owl-loaded')) {
             carousel.trigger('destroy.owl.carousel');
        }
    },
    methods: {
        initCarousel() {
            const carousel = $('#productCarousel');
            if (carousel.length) {
                carousel.owlCarousel({
                    loop: false,
                    margin: 20,
                    nav: true,
                    dots: true,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 2
                        },
                        1000: {
                            items: 4
                        }
                    }
                });
            }
        }
    }
}
</script>
